import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Search, Loader2 } from "lucide-react";
import { api } from "../lib/api";

export const FindTour = ({ big = false, testid = "find-tour" }) => {
  const [q, setQ] = useState("");
  const [sugs, setSugs] = useState([]);
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  const timer = useRef();
  useEffect(() => {
    clearTimeout(timer.current);
    if (q.trim().length < 2) { setSugs([]); return; }
    timer.current = setTimeout(async () => {
      const { data } = await api.get("/public/find", { params: { q } });
      setSugs(data.suggestions || []);
    }, 250);
  }, [q]);
  const go = async (e) => {
    e.preventDefault();
    if (!q.trim()) return;
    setBusy(true); setMsg("");
    try {
      const compact = q.replace(/\s+/g, "").toUpperCase();
      let { data } = await api.get("/public/find", { params: { q: q.trim() } });
      if (!data.match && compact !== q.trim()) ({ data } = await api.get("/public/find", { params: { q: compact } }));
      if (data.match) { nav(`/tours/${data.match.code}`); setQ(""); setSugs([]); }
      else if (data.suggestions?.length) setSugs(data.suggestions);
      else setMsg("No tour found with that code. Check the code from your group leader, or browse our tours.");
    } finally { setBusy(false); }
  };
  return (
    <form onSubmit={go} className="relative w-full" data-testid={`${testid}-form`}>
      <div className={`flex items-center rounded-full border border-slate-300 bg-white/95 shadow-sm ${big ? "p-1.5 pl-5" : "p-1 pl-3"}`}>
        <Search className={`text-slate-400 ${big ? "h-5 w-5" : "h-4 w-4"}`} />
        <input aria-label="Find your tour by code or destination" data-testid={`${testid}-input`} value={q} onChange={(e) => { setQ(e.target.value); setMsg(""); }}
          placeholder={big ? "Enter your tour code (e.g. ABC2027) or a destination" : "Find your tour (code)"} className={`min-w-0 flex-1 bg-transparent px-3 outline-none ${big ? "py-3 text-base" : "py-1.5 text-sm"}`} />
        <button data-testid={`${testid}-submit`} className={`btn-accent ${big ? "" : "btn-sm"}`} disabled={busy}>{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : big ? "Find Your Tour" : "Find"}</button>
      </div>
      {(sugs.length > 0 || msg) && (
        <div className="absolute left-0 right-0 top-full z-40 mt-2 overflow-hidden rounded-xl border bg-white text-left shadow-xl" data-testid={`${testid}-results`}>
          {msg && <p className="p-4 text-sm text-slate-600" data-testid={`${testid}-no-match`}>{msg}</p>}
          {sugs.map((s) => (
            <button type="button" key={s.slug || s.code} onClick={() => { nav(s.type === "tour" ? `/tours/${s.code}` : `/itineraries/${s.slug}`); setSugs([]); setQ(""); }}
              className="flex w-full items-center justify-between px-4 py-3 text-sm hover:bg-slate-50" data-testid={`${testid}-suggestion`}>
              <span className="font-medium text-slate-800">{s.title}</span><span className="text-xs text-slate-500">{s.destination} · {s.type === "tour" ? "Departure" : "Itinerary"}</span>
            </button>
          ))}
        </div>
      )}
    </form>
  );
};
